import { useSelectCategoriesData } from 'store/configuration/categories/selectors/selectors-hooks';
import { IPoi } from 'features/explore/model/poi-model/poi';
import { getCategoryIconUrl, getCategoryStaticIconUrl } from 'core/entities/category/utils';
import { isAddressType } from 'utils/poi-provider/poi-provider';
import { ADDRESS_ENTITY } from 'core/constants/address';
import { SquareLogoProps } from 'ui-components/square-logo/square-logo';

export const useSquareLogoProps = (poi: IPoi): SquareLogoProps => {
    const categoriesIconData = useSelectCategoriesData();

    const logoImgUrl = getCategoryIconUrl({
        categoriesIconData,
        info: poi.getPoiData(),
    });

    const basePOI = poi.getPoiData();

    return {
        logoUrl: poi.logoUrl.get(),
        icon:
            logoImgUrl ||
            getCategoryStaticIconUrl({
                info: basePOI,
            }) ||
            undefined,
        placeType: isAddressType(basePOI) ? ADDRESS_ENTITY : poi.type.get(),
        name: poi.name.get(),
    };
};
